<template>
  <div class="header">
    <TopNav />
    <b-container fluid class="header-middle">
      <b-row>
        <b-col cols="12" md="4" lg="3" class="p-0 mt-4 mt-md-1 d-none d-sm-block">
          <div class="logowrap">
            <router-link :to="{name: 'home'}">
              <SVGLogo class="logo_medika" />
            </router-link>
          </div>
        </b-col>
        <b-col cols="12" md="2" class="p-0"></b-col>
        <b-col cols="12" md="7" align-self="end" class="p-0 mt-4 mt-md-0">
          <SearchDrugsForm />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SVGLogo from "@/static/logo_vooy_market.svg";
import TopNav from "@/components/navigation/TopNav";
import SearchDrugsForm from "@/components/SearchDrugsForm";

export default {
  name: "the-heading",
  fallbackI18n: {
    messages: {
      und: {
        the_heading: {
          need_help: "Need help?",
        },
      },
    },
  },
  components: {
    TopNav,
    SearchDrugsForm,
    SVGLogo,
  },
};
</script>

<style lang="scss" scoped>
.logowrap img {
  height: 6rem;
  padding: 0px;
  margin: 0px;
}

.logo_medika {
  width: 100%;
  max-width: 100%;
}

@media screen and (min-width: 768px) {
  .logo_medika {
    width: 80%;
  }
}

.header-middle {
  border-top: 1px solid #e0e0e0;
}
</style>
